export const writeToClipboard = (type: string, blobFile: Blob) =>
  navigator.clipboard.write([
    // TODO: Исправить тайпинги
    new (window as any).ClipboardItem({
      [type]: blobFile,
    }),
  ]);

export const writePngToClipboard = (blobFile: Blob) =>
  writeToClipboard("image/png", blobFile);
